import { useEffect, useState } from "react";
import GraphTypeSelect, { GraphType } from "../../graphtype"

import { BarChart, PieChart } from "@mui/x-charts";
import { formatLocalCurrency } from "../../../../utils/currency";

import { showPorcetage } from "../../porcetage";
import { CltPropostalInfo } from "../types";

type CltChartPropostalParamInfoObj={[key:string]:CltChartPropostalParamInfo}
interface CltChartPropostalParamInfo{
    productionTotal:number,
    comissionTotal:number,
    parterComissionTotal:number,
    liquidComissionTotal:number,
    propostalsTotal:number
}



export function CltGraphTotalByGenericParam({propostals,param,showComission,label,showParamName}:{propostals:Array<CltPropostalInfo>,showComission?:boolean,param:string,label:string,showParamName?:(s:string)=>string}){
   const [graphType,setGraphType]=useState(GraphType.bar);
   const [paramsInfo,setParamsInfo]=useState<CltChartPropostalParamInfoObj>({});
   const [totalData,setTotalData]=useState<CltChartPropostalParamInfo>();
   useEffect(()=>{
        const calcInfo=calculateCltPropostalInfo(propostals,param,showParamName);
        setParamsInfo(calcInfo.paramsData);
        setTotalData(calcInfo.totalData)

   },[propostals]) 
   return (
    <div style={{textAlign:'center',justifyContent:'space-between'}}>
        <p>{label}</p>
        <GraphTypeSelect disabled={true} defaultValue={GraphType.bar} onChange={(s)=>setGraphType(s)}/>  
        {graphType==GraphType.bar?
         <>
         <div  style={{display:'flex'}}>
            <div>
            <p>Produção Liquida R$</p>
            <_BarChart totalInfo={totalData} paramsInfo={paramsInfo} isCurrency={true} showedParam="productionTotal"/>
            </div>
            <div>
            <p>Número de Propostas</p>
            <_BarChart totalInfo={totalData} paramsInfo={paramsInfo} isCurrency={false} showedParam="propostalsTotal"/>
            </div>
        </div>
        {
                showComission?<div style={{display:'flex'}}>
                    <div>
                <p>Comissão Total R$</p>
                 <_BarChart totalInfo={totalData} paramsInfo={paramsInfo} isCurrency={true} showedParam="comissionTotal"/>
                </div>
                <div>
                <p>Comissão Liquida R$</p>
                 <_BarChart totalInfo={totalData} paramsInfo={paramsInfo} isCurrency={true} showedParam="liquidComissionTotal"/>
                </div>
                </div>:<></>
            }
        </>:<></>}
    </div>
)
}

function _BarChart({paramsInfo,showedParam,totalInfo,isCurrency}:{paramsInfo:CltChartPropostalParamInfoObj,totalInfo?:CltChartPropostalParamInfo,showedParam:string,isCurrency?:boolean}){
  
  return <div>
     <BarChart
  xAxis={[{ scaleType: 'band',label:isCurrency?'R$':undefined, data: Object.keys(paramsInfo).map(e=>e)}]}
  series={[{ data: Object.values(paramsInfo).map(e=>{
    //@ts-ignore
    return e[showedParam]
   }),
   //@ts-ignore
   valueFormatter:(v)=>showPorcetage(v,totalInfo[showedParam],isCurrency?formatLocalCurrency:undefined)
  }]
   
   }
  width={500}
  height={300}
  
/>
  </div>
}



function calculateCltPropostalInfo(propostals:Array<CltPropostalInfo>,param:string,showParamName?:(p:string)=>string){
     let paramsData:CltChartPropostalParamInfoObj={};
     let totalData:CltChartPropostalParamInfo={
         productionTotal:0,
         comissionTotal:0,
         parterComissionTotal:0,
         liquidComissionTotal:0,
         propostalsTotal:0
     }
     for(let prop of propostals){
         let pName=getParamInfo(prop);
         if(!paramsData[pName]){
              paramsData[pName]={
                   productionTotal:0,
                   comissionTotal:0,
                   parterComissionTotal:0,
                   liquidComissionTotal:0,
                   propostalsTotal:0
              }
         }
         const liquidComission=(prop.totalComission-prop.partnerComission)/100;
         paramsData[pName].productionTotal+=prop.liquidValue/100;
         paramsData[pName].comissionTotal+=prop.totalComission/100;
         paramsData[pName].parterComissionTotal+=prop.partnerComission/100;
         paramsData[pName].liquidComissionTotal+=liquidComission;
         paramsData[pName].propostalsTotal++;
         totalData.productionTotal+=prop.liquidValue/100;
         totalData.comissionTotal+=prop.totalComission/100;
         totalData.parterComissionTotal+=prop.partnerComission/100;
         totalData.liquidComissionTotal+=liquidComission;
         totalData.propostalsTotal++;

     }
     
     return {
         paramsData,totalData
     }
     function getParamInfo(p:CltPropostalInfo){
         //@ts-ignore 
         let ret:string|number=p[param];
         if(!ret){
            ret='unknown';
         }
         if(typeof(ret)!=='string'){
              ret=ret.toString();
         }
         if(!showParamName)return ret;
         return showParamName(ret);
     }
}

